<script context="module">
  export interface IStatusPanel {
    buildingPermitReceived: string;
    buildingPermitSent: string;
    contactPerson: IContact;
    currentStatusItem: IStatusItem | null;
    statusItems: IStatusItem[];
    subtitle: string;
    title: string;
  }

  export interface IStatusItem {
    deadline: string;
    name: string;
    showWarning: boolean;
  }
</script>

<script>
  import AsideBlock from "../AsideBlock.svelte";
  import UserInfo from "../UserInfo.svelte";
  import type { IContact } from "../UserInfo.svelte";
  import { t } from "../../../core";
  import ItemRow from "./ItemRow.svelte";

  export let statusPanel: IStatusPanel;

  let isListDisplayed: boolean = false;

  function toggleList() {
    isListDisplayed = !isListDisplayed;
  }
</script>

{#if statusPanel}
  <AsideBlock title={statusPanel?.title} iconName="case-overview">
    <div slot="subtitle" class="subtuitle">{statusPanel?.subtitle}</div>

    <div class="status-wrapper">
      <div class="status-table">
        <div class="status-table__header">
          <div class="status-table__header-cell">
            {t("StatusPanel.Header.Name")}
          </div>
          <div class="status-table__header-cell">
            {t("StatusPanel.Header.Deadline")}
          </div>
        </div>
        <div class="status-table__body">
          {#if statusPanel.currentStatusItem}
            <ItemRow
              name={statusPanel.currentStatusItem.name}
              deadline={statusPanel.currentStatusItem.deadline}
              showWarning={statusPanel.currentStatusItem.showWarning}
            />
          {/if}

          {#if isListDisplayed}
            {#each statusPanel.statusItems as status}
              <ItemRow
                name={status.name}
                deadline={status.deadline}
                showWarning={status.showWarning}
              />
            {/each}
          {/if}
        </div>
      </div>

      <button class="link" on:click={toggleList}>
        {t(
          isListDisplayed
            ? "StatusPanel.Statuses.HideAll"
            : "StatusPanel.Statuses.ShowAll"
        )}
      </button>
    </div>

    <div class="permission">
      <div class="permission__row">
        <p class="permission__title">{t("StatusPanel.Permission.Sent")}</p>
        <p class="permission__info">{statusPanel.buildingPermitSent}</p>
      </div>
      <div class="permission__row">
        <p class="permission__title">{t("StatusPanel.Permission.Received")}</p>
        <p class="permission__info">{statusPanel.buildingPermitReceived}</p>
      </div>
    </div>

    {#if statusPanel?.contactPerson}
      <div class="user-info">
        <p class="user-info__title">{t("StatusPanel.Contact.Title")}</p>
        <UserInfo data={statusPanel?.contactPerson} />
      </div>
    {/if}
  </AsideBlock>
{/if}

<style lang="scss">
  .user-info {
    &__title {
      @include small;
      font-weight: 900;
      margin-bottom: 20px;
    }
  }

  .status-wrapper {
    border-bottom: 1px solid $separator-color;
    padding-bottom: 25px;
    margin-bottom: 25px;

    .link {
      font-size: 13px;
    }
  }

  .status-table {
    @include small;

    &__header {
      display: grid;
      grid-template-columns: 1fr 0.5fr;
      grid-column-gap: 10px;
      padding-bottom: 10px;
      margin-bottom: 10px;
      border-bottom: 1px solid $separator-color;
      font-weight: 900;
      color: $text-color;
    }

    &__body {
      margin-bottom: 16px;
      color: $text-color;
    }
  }

  .permission {
    @include small;
    color: $text-color;
    padding-bottom: 25px;
    margin-bottom: 25px;
    border-bottom: 1px solid $separator-color;

    &__row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 10px;
      margin-bottom: 5px;

      &:last-of-type {
        margin-bottom: unset;
      }
    }

    &__title {
      font-weight: 900;
    }
  }
</style>
